<template>
    <div class="accordion-container">
        <Accordion
            :open="true"
            title="4.1. Bild als Hintergrund"
            info="Lade ein Bild oder Foto in möglichst hoher Auflösung hoch. Links kannst du es zuschneiden und positionieren.">
            <ImageBackground class="mb-3"></ImageBackground>
        </Accordion>

        <!--
        <Accordion
            :open="backgroundConfiguration.type == 'text' || this.openAccordion==2"
            title="3.2. Text als Hintergrund"
            info="Gib einen Text in das Feld ein. Die formatfüllende Variante erscheint einmal, die wiederholende mehrfach auf dem ganzen Bild. Wähle zusätzlich Schriftart, Schriftfarbe, Textgröße und Transparenz."
            :showCheckbox="true"
            @click="toggleAccordion(2)">
            <TextBackground class="mb-3"></TextBackground>
        </Accordion>
        -->
    </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';
import ColorPreset from "./ColorPreset.vue";
import TextBackground from "./TextBackground.vue";
import Pipeline from '../../../Pipeline/Pipeline';
import ImageBackground from "./ImageBackground.vue";
import Accordion from "~/scripts/Components/Accordion.vue";

export default {
    components: {
        Accordion,
        ColorPreset,
        ImageBackground,
        TextBackground
    },
    data() {
        return {
            openAccordion: 0,
            backgroundConfiguration: this.$store.state.stageConfiguration.background
        }
    },
    methods: {
        toggleAccordion(number) {
            this.openAccordion = number != this.openAccordion ? number : 0;

            this.$store.commit('updateField', {
                path: 'stageConfiguration.background.type',
                value: this.openAccordion == 1 ? 'image' : (this.openAccordion == 2 ? 'text' : '')
            });

            Pipeline.setTextBackground();
            Pipeline.setImageBackground();
        }
    }
};
</script>
